export default {
  editTitle: 'Edit Plan Optimization',
  newTitle: 'New Plan Optimization',
  save: 'Save',
  create: 'Create',
  advancedSettings: 'Advanced Settings',
  planName: 'Plan Name',
  startDate: 'Start date',
  endDate: 'End date',
  budget: 'Total Budget',
  budgetRestrictions: 'Budget restrictions',
  mediaTouchpoints: 'Turn On/Off Media Touchpoints',
  segments: 'Segments',
  nameRequired: 'Name is required',
  dateRequired: 'Date is required',
  mustBeAfterStartDate: 'Must be after start date',
  budgetRequired: 'Budget is required',
  restrictionsForceOverBudget: '(Restrictions force investment over budget)',
  timeRestrictionsForceOverBudget: '(Time restrictions force investment over budget)',
  restrictionsForceUnderBudget: '(Restrictions force investment under budget)',
  invalidRestrictionLessThanZero: '(Invalid restriction. Cannot invest less than zero)',
  invalidRestrictionMinOverMax: '(Invalid restriction. Min cannot be larger than Max)',
  tryNewOptimizer: 'Try the new optimizer?',
  betaUnavailableTooltip: "The new optimizer isn't available for this model yet.",
  budgetAllocationRequirement: 'Budget Allocation Requirement',
  mustSpendExactly: 'Must spend exactly',
  canSpendUpTo: 'Can spend up to',
  restrictions: 'Restrictions',
  externalVariablesOptional: 'External Variables (optional)',
  kpiWeighting: 'KPI Weighting',
  kpiAutoBalance: 'Auto-Balance',
  kpiCustomWeights: 'Custom Weights by KPI',
  kpiWeightsTotal: 'Total',
  kpiWeightsMustEqual100: 'Weights must add up to 100%',
  kpiWeightingHint: 'Assign weights to each KPI. The optimizer will prioritize channels and tactics that drive these outcomes. Total must equal 100%.',
  enableTime: 'Enable Time-based Restrictions',
  timeRestrictions: 'Time restrictions',
  selectDateRange: 'Select a valid date range to configure time restrictions',
  dateChangeBlockedByRestrictions: 'Cannot change the plan dates. Existing time restrictions reference months that would fall outside the new period. Remove or edit those restrictions first.',
  feasibleChip: 'Feasible plan',
  feasibility_infeasible: 'These restrictions cannot be satisfied. Relax the restrictions or adjust the budget.',
  feasibility_channelMinExceedsCapacity: '{channel} cannot reach its required minimum within this period. Lower its minimum or extend the date range.',
  feasibility_channelMinExceedsMax: '{channel} has a minimum larger than its maximum. Fix that restriction.',
  feasibility_sumOfMinimumsExceedsBudget: 'The required minimums add up to more than the budget. Lower some minimums or raise the budget.',
  feasibility_budgetExceedsMaxCapacity: 'The budget is larger than the selected channels can absorb in this period. Lower the budget, add channels, or relax the maximums.',
  feasibility_groupMinExceedsCapacity: '{channels} together cannot reach their required minimum within this period. Lower that minimum or extend the date range.',
  feasibility_groupMinExceedsMax: 'The combined restriction on {channels} has a minimum larger than its maximum. Fix that restriction.',
  feasibility_channelConflictingRestrictions: 'The restrictions on {channel} conflict with each other: one requires spending more than another allows. Fix those restrictions.',
  feasibility_restrictionOnUnselectedChannel: '{channels} has a restriction but is unchecked in Media Touchpoints. Remove the restriction or re-select the channel.',
  feasibility_noChannelsSelected: 'No media channels are selected. Select at least one touchpoint.'
}
